export class TrainingGroup {
    constructor(
        public key: string,
        public name: string,
        public isTeam: boolean,
        public contestants: Array<number>,
        public assignedLane: Array<number> = [],
    ) {}
}
